"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProspectingBatchMessagingVideoType = exports.ProspectingBatchGiftsFinishedStatus = exports.ProspectingBatchGiftsStatus = void 0;
var ProspectingBatchGiftsStatus;
exports.ProspectingBatchGiftsStatus = ProspectingBatchGiftsStatus;

(function (ProspectingBatchGiftsStatus) {
  ProspectingBatchGiftsStatus["Idle"] = "idle";
  ProspectingBatchGiftsStatus["Pending"] = "pending";
  ProspectingBatchGiftsStatus["Finished"] = "finished";
})(ProspectingBatchGiftsStatus || (exports.ProspectingBatchGiftsStatus = ProspectingBatchGiftsStatus = {}));

var ProspectingBatchGiftsFinishedStatus;
exports.ProspectingBatchGiftsFinishedStatus = ProspectingBatchGiftsFinishedStatus;

(function (ProspectingBatchGiftsFinishedStatus) {
  ProspectingBatchGiftsFinishedStatus["Idle"] = "idle";
  ProspectingBatchGiftsFinishedStatus["Pending"] = "pending";
  ProspectingBatchGiftsFinishedStatus["Finished"] = "finished";
})(ProspectingBatchGiftsFinishedStatus || (exports.ProspectingBatchGiftsFinishedStatus = ProspectingBatchGiftsFinishedStatus = {}));

var ProspectingBatchMessagingVideoType;
exports.ProspectingBatchMessagingVideoType = ProspectingBatchMessagingVideoType;

(function (ProspectingBatchMessagingVideoType) {
  ProspectingBatchMessagingVideoType["Embed"] = "embed";
  ProspectingBatchMessagingVideoType["Vidyard"] = "vidyard";
})(ProspectingBatchMessagingVideoType || (exports.ProspectingBatchMessagingVideoType = ProspectingBatchMessagingVideoType = {}));